import { Component, Input } from '@angular/core';
import { VirtualUrgentCareOptionCardComponent } from '../virtual-urgent-care-option-card/virtual-urgent-care-option-card.component';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-virtual-urgent-care-mobile',
  imports: [VirtualUrgentCareOptionCardComponent,CommonModule, TranslateModule, MatProgressSpinnerModule, MatCardModule, MatButtonModule],
  templateUrl: './virtual-urgent-care.component.html',
  styleUrl: '../../../../../styles.css'
})
export class VirtualUrgentCareComponent {

  @Input() locale: string | null = null;
  @Input() isPlus: boolean | null = null;
  @Input() virtualUrgentCareOptions: Array<any> = [];

  public title: string = 'TITLE';
  public description: string = 'DESCRIPTION';
  public showMoreText: string = 'SHOW_MORE'; 

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(this.locale || 'en-US'); // Default to 'en-US' if no locale is provided'
  }

  ngOnInit(): void {
   this.translate.get('VIRTUALURGENTCARE.TITLE').subscribe((translated: string) => {
      this.title = translated;
    });

    this.translate.get('VIRTUALURGENTCARE.DESCRIPTION').subscribe((translated: string) => {
      this.description = translated;
    });

    this.translate.get('SHOW_MORE').subscribe((translated: string) => {
      this.showMoreText = translated;
    });
  }

  showMeMore() {
    const eptID = sessionStorage.getItem("eptID");
    const isMobile = window.location.href.includes('mobile');

    if (eptID == null || eptID == undefined || eptID == "") {
      this.showMeMoreUnAuth(isMobile); 
    }
    else {
      this.showMeMoreAuth();
    }
  }

  showMeMoreUnAuth(isMobile: boolean) {
    // mobile deeplink --> mymemorialcare://openscheduling/standalone?id=7000892&vt=52216,52220
    var deeplink = isMobile ? environment.mobile_open_scheduling_deep_link_base_url : environment.web_open_scheduling_deep_link_base_url; 
    
    deeplink += "/standalone?id=" + environment.generic_vuc_provider_id
      + "&vt=" + environment.adult_vuc_rfv_id
      + "&linksource=PLUAVUC";
      
    this.monitoringService.logEvent('ShowMore/NoAuth', { feature: 'get-care-now', subfeature: 'VUC', platform: 'web' }); // log as web event
    
    console.log("VUC Now clicked (IPUC)");
    console.log(deeplink);
    window.location.href = deeplink;
  }


  showMeMoreAuth() {
    var deepLink = '';

    if (this.isPlus == null) {
      deepLink = environment.web_vuc_deep_link_base_url; // For web users, use the web deep link
      this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'VUC', platform: 'web' }); // log as mobile or web event
    }
    else {
      deepLink = this.isPlus == true
        ? environment.mobile_vuc_deep_link_base_url // For Plus users, use the mobile deep link
        : environment.epic_vuc_deep_link_base_url; //  For non-Plus users, use the epic deep link

      var mobilePlatform = this.isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'VUC', platform: mobilePlatform }); // log as mobile or web event
    }

    const age = sessionStorage.getItem("age");
    var ageNumber = age ? parseInt(age) : null;

    if (ageNumber != null) {
        deepLink += ageNumber < 18 
          ? environment.pediatric_vuc_prc_id
          : environment.adult_vuc_prc_id;
    }
    
    deepLink += "&linksource=AUTHVUCSCHED";
    
    console.log("Show me more clicked (vuc)");
    console.log(deepLink);
    

    window.location.href = deepLink;
  }

}
